import PropTypes from 'prop-types';
import styled from 'helpers/styles';
import ComponentStyles from 'styles/mixins/Component.styles';
import {MenuButtonStrikethrough} from 'mui-tiptap';

const StyledEditorMenuButtonStrikethrough = styled(MenuButtonStrikethrough)`
  ${ComponentStyles}
`;

StyledEditorMenuButtonStrikethrough.propTypes = {
  theme: PropTypes.object
};

export default StyledEditorMenuButtonStrikethrough;
